module.exports = __webpack_public_path__ + "img/ホンダ.b8b4fc0b.png";